import { formatDate } from '@angular/common';

export type CrmDateFormatKey = 'Default' | 'CanadianBritish' | 'American' | 'European' | 'International' | 'Sortable';

export interface CrmDateFormatOption {
  value: CrmDateFormatKey;
  label: string;
  format: string;
}

export const CRM_DATE_FORMAT_OPTIONS: CrmDateFormatOption[] = [
  { value: 'Default', label: 'Default', format: 'dd MMM yyyy' },
  { value: 'CanadianBritish', label: 'Canadian/British', format: 'dd-MM-yyyy' },
  { value: 'American', label: 'American', format: 'MM/dd/yy' },
  { value: 'European', label: 'European', format: 'dd.MM.yyyy' },
  { value: 'International', label: 'International', format: 'dd-MM-yyyy' },
  { value: 'Sortable', label: 'Sortable', format: 'yyyy.MM.dd' }
];

export const CRM_DATE_FORMAT_STRINGS: Record<CrmDateFormatKey, string> = CRM_DATE_FORMAT_OPTIONS.reduce(
  (formats, option) => ({
    ...formats,
    [option.value]: option.format
  }),
  {} as Record<CrmDateFormatKey, string>
);

export function formatCrmDateOptionPreview(option: CrmDateFormatOption, date: Date): string {
  return formatDate(date, option.format, 'en-US');
}
